/** UI copy for traininghausmaus.com — English + Bulgarian */
export const SUPPORTED = [
  { code: 'en', label: 'English' },
  { code: 'bg', label: 'Български' },
];

export const strings = {
  en: {
    brand: 'TrainingHausMaus',
    brandDomain: 'traininghausmaus.com',
    nav: {
      home: 'Home',
      discover: 'Discover',
      features: 'Features',
      advantages: 'Your edge',
      faq: 'FAQ',
      contact: 'Contact',
    },
    headerCta: 'Continue',
    hero: {
      badge: 'Fitness portal for enthusiasts & pros',
      titleA: 'Stay fit,',
      titleB: 'stay happy',
      titleC: 'Success is what you make of it.',
      lead:
        'TrainingHaus is your fitness portal — premium plans, proven exercises, and nutrition guidance you can follow at your own pace, anywhere.',
      ctaPrimary: 'Get started',
      ctaSecondary: 'See how it works',
      legal:
        'Subscription €6.14 / 12.01 BGN per month incl. VAT — auto-renewing. Enter your mobile number and the PIN you receive by SMS to access the service. By subscribing you accept the general terms. Your operator may charge for data. Customer care: thaus.bg@silverlines.info, +35924917971 (local call). Service provided by Business Fleet s.r.o., Lidická 700/19, Veveří, 602 00 Brno, Czech Republic. Minimum age 18.',
      statTitle: '12 000+ members',
      statSub: 'training on their terms',
      priceChip: '€6.14 / mo · VAT incl.',
    },
    discover: {
      kicker: 'Discover',
      title: 'Reach your goals',
      titleGrad: 'at your rhythm',
      body:
        'Weekly workout and meal structure helps you improve conditioning without burning out. Warm-up, session, fuel — structured, not overwhelming.',
      devicesTitle: 'Works in the browser',
      devicesSub: 'Phone, tablet, or desktop — no install required.',
    },
    features: {
      kicker: 'Inside the portal',
      items: [
        {
          title: 'Session blueprints',
          description: 'Clear progressions from first session to confident training — video-led, form-first.',
        },
        {
          title: 'Nutrition rhythm',
          description: 'Simple rules, practical meals — vegan, vegetarian, or classic patterns.',
        },
        {
          title: 'Outcome tracking',
          description: 'Lightweight logs so you see momentum without living in spreadsheets.',
        },
        {
          title: 'Audio for focus',
          description: 'Curated energy for sessions — push sets without hunting playlists.',
        },
        {
          title: 'Deep-dive guides',
          description: 'Readable long-form on recovery, mobility, and sustainable habits.',
        },
        {
          title: 'Coach-grade articles',
          description: 'Short expert notes when you need a nudge between sessions.',
        },
      ],
    },
    how: {
      kicker: 'How it works',
      title: 'No gimmicks —',
      titleGrad: 'just consistency',
      intro:
        'The right mix of movement and food for results that stick. We show the path; you set the pace.',
      blocks: [
        {
          title: 'HD training blocks',
          description: 'Follow-along sessions with clear cues — beginner-friendly to advanced.',
          points: ['Fresh blocks added often', 'Strength, cardio, mobility', 'Step-by-step coaching'],
        },
        {
          title: 'Meal patterns that fit',
          description: 'Few rules, useful structure — quick recipes you can repeat.',
          points: ['Balanced defaults', 'Goal-aware swaps', 'Minimal prep options'],
        },
        {
          title: 'Visible progress',
          description: 'Small wins add up — see streaks and volume without obsession.',
          points: ['Weekly snapshot', 'Personal targets', 'Honest metrics'],
        },
        {
          title: 'Daily micro-coaching',
          description: 'Bite-sized tips on technique, sleep, and mindset between workouts.',
          points: ['Expert notes', 'Injury-aware cues', 'Habit prompts'],
        },
      ],
    },
    advantages: {
      kicker: 'Your advantages',
      title: 'Train anywhere.',
      titleGrad: 'Built around you.',
      intro: 'Personalised pacing, long-term focus — no crash diets or random PDFs.',
      quote: 'Build the body you want to live in.',
      quoteSub: 'We show you how to get in shape clearly — without needless complexity.',
      bullets: ['Train anywhere.', 'Personalised for you.', 'Built for long-term success.'],
      cta: 'Start now',
      panelTitle: 'Nutrition lane',
      panelKicker: 'MEAL RHYTHM',
      panelBody: 'Little rules, lots of useful detail. Lose weight healthily — and keep it.',
      panelSub: 'Your workout. Proven moves. Lasting results — matched to your level.',
      imageAlt: 'Athlete mid-session',
      panelAlt: 'Colourful balanced meal',
    },
    cta: {
      badge: 'Ready when you are',
      title: 'Own your training',
      titleSub: 'this week.',
      body: 'Unlock premium TrainingHaus content — structured training and nutrition in one place.',
      perks: [
        'Premium portal access',
        'Workout + meal structure',
        'Cancel with 14 days notice',
        'Use on any modern browser',
      ],
      button: 'Continue',
      priceLine: '€6.14 / 12.01 BGN per month incl. VAT — auto-renewal.',
      helpLine: 'Manage or cancel: +35924917971 · thaus.bg@silverlines.info',
      legalBox:
        'Welcome to TrainingHaus — a fitness portal for enthusiasts and professionals. Subscription includes premium access at €6.14 / 12.01 BGN per month. Enter your mobile number and SMS PIN to use the service. By subscribing you confirm acceptance of the general terms. Data charges from your operator may apply. Customer care: thaus.bg@silverlines.info, +35924917971. Provided by Business Fleet s.r.o., Lidická 700/19, Veveří, 602 00 Brno, Czech Republic.',
    },
    faq: {
      kicker: 'FAQ',
      title: 'Answers',
      titleGrad: 'in one place',
      intro: 'Common questions about TrainingHaus and your subscription.',
      items: [
        {
          q: 'How do I subscribe?',
          a: 'Tap Continue, enter your mobile number, then confirm with the PIN sent by SMS. After confirmation you complete opt-in on the payment step as shown on the portal.',
        },
        {
          q: 'Which devices are supported?',
          a: 'Any up-to-date browser on phone, tablet, or computer. For security we recommend one of the latest three versions of major browsers.',
        },
        {
          q: 'What does it cost?',
          a: '€6.14 / 12.01 Bulgarian lev per month including VAT, with automatic renewal until you cancel under the terms.',
        },
        {
          q: 'How do I cancel?',
          a: 'You may cancel with 14 days notice before the end of the current period by calling +35924917971 or emailing thaus.bg@silverlines.info. The cancellation date is the date we receive your notice.',
        },
        {
          q: 'My question is not listed',
          a: 'Write to thaus.bg@silverlines.info or call +35924917971 — we will help with access, billing, or technical issues.',
        },
      ],
      contactTitle: 'Still unsure?',
      contactLead: 'Reach out — we respond during business hours.',
      email: 'thaus.bg@silverlines.info',
      phoneDisplay: '+359 2491 7971',
    },
    footer: {
      blurb:
        'TrainingHausMaus — premium fitness and nutrition content on traininghausmaus.com. Subscription €6.14 / month incl. VAT. Operator: Business Fleet s.r.o.',
      legalShort:
        'Cancel with 14 days notice before renewal by phone or email. Age 18+. See terms for billing, failed payment fees, and withdrawal rights.',
      navTitle: 'Navigate',
      contactTitle: 'Contact',
      cta: 'Continue →',
      copyright: 'TrainingHausMaus. Service: Business Fleet s.r.o. All rights reserved.',
      privacy: 'Privacy',
      terms: 'Terms',
      imprint: 'Provider information',
    },
    termsLinks: 'General terms | Information',
  },
  bg: {
    brand: 'TrainingHausMaus',
    brandDomain: 'traininghausmaus.com',
    nav: {
      home: 'Начало',
      discover: 'Открий',
      features: 'Функции',
      advantages: 'Предимства',
      faq: 'Въпроси',
      contact: 'Контакт',
    },
    headerCta: 'Продължи',
    hero: {
      badge: 'Фитнес портал за любители и професионалисти',
      titleA: 'Бъди във форма',
      titleB: 'и щастлив',
      titleC: 'Успех е онова, което ти направиш от него.',
      lead:
        'Добре дошли в TrainingHaus — поддържайте форма с нашето съдържание: тренировки, хранене и мотивация в удобно за теб темпо.',
      ctaPrimary: 'Започни',
      ctaSecondary: 'Виж още',
      legal:
        'Абонамент за 6,14 EUR / 12,01 лв на месец с ДДС – автоматично подновяване. За достъп до услугата въведете мобилния си номер и ПИН кода, който ще получите по SMS. Абонирайки се, потвърждавате съгласието си с общите условия. Възможни са допълнителни такси за интернет трафик от вашия мобилен оператор. Обслужване на клиенти: thaus.bg@silverlines.info, +35924917971 (местен разговор). Услугата се предоставя от Business Fleet s.r.o., Lidická 700/19, Veveří, 602 00 Бърно, Чехия. Навършили 18 години.',
      statTitle: '12 000+ потребители',
      statSub: 'тренират с нас',
      priceChip: '6,14 EUR / месец · с ДДС',
    },
    discover: {
      kicker: 'Открий',
      title: 'Постигни целите си',
      titleGrad: 'в собствено темпо',
      body:
        'Със седмичния план за тренировки и хранене можеш да подобриш физическата си форма със собствено темпо. Загряване, тренировка и хранене.',
      devicesTitle: 'Достъп през браузър',
      devicesSub: 'Телефон, таблет или компютър — без инсталация.',
    },
    features: {
      kicker: 'В портала',
      items: [
        {
          title: 'Структурирани тренировки',
          description: 'Доказани упражнения и ясни серии — подходящо за различно ниво.',
        },
        {
          title: 'Хранителен режим',
          description: 'Малко правила, много полезна информация — лесни и бързи рецепти.',
        },
        {
          title: 'Проследяване',
          description: 'Виж прогреса си без сложни таблици.',
        },
        {
          title: 'Музика за фокус',
          description: 'Плейлисти за енергия по време на тренировка.',
        },
        {
          title: 'Гайдове',
          description: 'Дълбоки материали за възстановяване и навици.',
        },
        {
          title: 'Статии от експерти',
          description: 'Кратки съвети между тренировките.',
        },
      ],
    },
    how: {
      kicker: 'Как работи',
      title: 'Без прекия път!',
      titleGrad: 'Трайни резултати',
      intro:
        'Идеалната комбинация от упражнения и хранене за трайни резултати. Ние показваме пътя — ти избираш темпото.',
      blocks: [
        {
          title: 'Видео тренировки',
          description: 'Високо качество, стъпка по стъпка — от начинаещи до напреднали.',
          points: ['Нови сесии', 'Различни стилове', 'Ясни инструкции'],
        },
        {
          title: 'Рецепти и режим',
          description: 'Веганско, вегетарианско или класическо — подходящо за всеки.',
          points: ['Баланс', 'По цел', 'Бързо готвене'],
        },
        {
          title: 'Напредък',
          description: 'Седмични и месечни прегледи и лични цели.',
          points: ['Визуален дневник', 'Обобщение', 'Мотивация'],
        },
        {
          title: 'Съвети всеки ден',
          description: 'Техника, издръжливост и ментална устойчивост.',
          points: ['От треньори', 'Превенция', 'Навици'],
        },
      ],
    },
    advantages: {
      kicker: 'Твоите предимства',
      title: 'Тренирай навсякъде.',
      titleGrad: 'Персонализирано за теб.',
      intro: 'Дългосрочен успех — без крайни диети и хаос.',
      quote: 'Изграждай тялото във форма',
      quoteSub: 'Ще ти покажем как да влезеш във форма бързо и лесно, без излишни усложнения.',
      bullets: ['Тренирай навсякъде.', 'Персонализирано за теб.', 'Дългосрочен успех.'],
      cta: 'Започни',
      panelTitle: 'Хранителен режим',
      panelKicker: 'ХРАНЕНЕ',
      panelBody: 'Малко правила, много полезна информация.',
      panelSub:
        'Отслабни здравословно и за постоянно. Твоята тренировка. Доказани упражнения. Трайни резултати.',
      imageAlt: 'Тренировка',
      panelAlt: 'Здравословно хранене',
    },
    cta: {
      badge: 'Започни днес',
      title: 'Вземи контрол',
      titleSub: 'на тренировката си!',
      body: 'С абонамента получавате достъп до премиум съдържание на цена 6,14 EUR / 12,01 лв на месец.',
      perks: [
        'Премиум достъп',
        'План за тренировки и хранене',
        'Прекратяване с 14 дни предизвестие',
        'Всички съвременни браузъри',
      ],
      button: 'Продължи',
      priceLine: '6,14 EUR / 12,01 лв на месец с ДДС – автоматично подновяване',
      helpLine: 'Управление на абонамента: +35924917971 · thaus.bg@silverlines.info',
      legalBox:
        'Добре дошли в TrainingHaus! Фитнес портал за любители и професионалисти – поддържайте форма с нашето съдържание. С абонамента получавате достъп до премиум съдържание на цена 6,14 EUR / 12,01 лв на месец. За достъп до услугата въведете мобилния си номер и ПИН кода, който ще получите по SMS. Абонирайки се, потвърждавате съгласието си с общите условия. Възможни са допълнителни такси за интернет трафик от вашия мобилен оператор. Обслужване на клиенти: thaus.bg@silverlines.info, +35924917971 (местен разговор). Услугата се предоставя от Business Fleet s.r.o., Lidická 700/19, Veveří, 602 00 Бърно, Чехия.',
    },
    faq: {
      kicker: 'Въпроси',
      title: 'Често задавани',
      titleGrad: 'въпроси',
      intro: 'Отговори за TrainingHaus и абонамента.',
      items: [
        {
          q: 'Как се абонирам?',
          a: 'Натиснете „Продължи“, въведете мобилен номер и потвърдете с ПИН по SMS. След това следвайте стъпките за плащане на портала.',
        },
        {
          q: 'Кои устройства се поддържат?',
          a: 'Модерен браузър на телефон, таблет или компютър. Препоръчваме последните три версии на основните браузъри.',
        },
        {
          q: 'Каква е цената?',
          a: '6,14 EUR / 12,01 лв на месец с включен ДДС, с автоматично подновяване до прекратяване според Общите условия.',
        },
        {
          q: 'Как прекратявам абонамента?',
          a: 'С предизвестие 14 дни преди края на периода — на +35924917971 или thaus.bg@silverlines.info. За валидна дата се счита датата на получаване на уведомлението.',
        },
        {
          q: 'Друг въпрос',
          a: 'Пишете на thaus.bg@silverlines.info или се обадете на +35924917971.',
        },
      ],
      contactTitle: 'Нужда от помощ?',
      contactLead: 'Свържете се с нас — отговаряме в работни часове.',
      email: 'thaus.bg@silverlines.info',
      phoneDisplay: '+359 2491 7971',
    },
    footer: {
      blurb:
        'TrainingHausMaus — премиум фитнес съдържание на traininghausmaus.com. Абонамент 6,14 EUR / месец с ДДС. Оператор: Business Fleet s.r.o.',
      legalShort:
        'Прекратяване с 14 дни предизвестие преди подновяване по телефон или имейл. 18+. Виж Общите условия за плащане и отказ.',
      navTitle: 'Навигация',
      contactTitle: 'Контакт',
      cta: 'Продължи →',
      copyright: 'TrainingHausMaus. Услуга: Business Fleet s.r.o. Всички права запазени.',
      privacy: 'Поверителност',
      terms: 'Общи условия',
      imprint: 'Информация за доставчика',
    },
    termsLinks: 'Общи условия | Информация',
  },
};
